import {
  GraphQLID,
  GraphQLInputType,
  GraphQLList,
  GraphQLNonNull,
  GraphQLString
} from 'graphql'

interface TypePresetConfig {
  readonly type: GraphQLInputType
  readonly typeString: string
}

const typeRequiredId: TypePresetConfig = {
  type: new GraphQLNonNull(GraphQLID),
  typeString: 'ID!'
}

const typeRequiredString: TypePresetConfig = {
  type: new GraphQLNonNull(GraphQLString),
  typeString: 'String!'
}

const typeRequiredListOfStrings: TypePresetConfig = {
  type: new GraphQLNonNull(new GraphQLList(GraphQLString)),
  typeString: '[String]!'
}

export const commonTypes = {
  typeRequiredId,
  typeRequiredString,
  typeRequiredListOfStrings
}
